import React, { useState, useEffect } from "react";
import styles from "./GifImageSlider.module.css";

import img1 from '../../assets/project-imgs/Dashboards.png'
import img2 from '../../assets/project-imgs/Memberss.png'
import img3 from '../../assets/project-imgs/Payments.png'
// import img4 from '../../assets/project-imgs/Report1.png'
// import img5 from '../../assets/project-imgs/Report2.png'
import img4 from '../../assets/project-imgs/Complaints.png'
import img5 from '../../assets/project-imgs/ComplaintResolve.png'


const images = [img1, img2, img3, img4, img5, ];

const GifImageSlider = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000); // change slide every 3 seconds

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.slideshowContainer}>
      {images.map((img, i) => (
        <div
          key={i}
          className={`${styles.slide} ${
            i === index ? styles.active : ""
          }`}
        >
          <img src={img} alt={`slide-${i}`} />
        </div>
      ))}
    </div>
  );
};

export default GifImageSlider;
